import { useGetNotificationsCountQuery } from '../../infrastructure/api/notifications.api';

export function useNotificationsCount(skip = false) {
  const { data, isLoading, isFetching, isError } = useGetNotificationsCountQuery(
    undefined,
    {
      skip,
      pollingInterval: skip ? 0 : 60_000,
    },
  );

  const conversations = data?.conversations ?? [];
  const count = conversations.reduce((sum, row) => sum + row.count, 0);

  return {
    conversations,
    count,
    isLoading,
    isFetching,
    isError,
  };
}
